import React from "react";
import { ManageTradeLayout } from "../../../components";
import { Button, Image } from "react-bootstrap";
import { manageTradeFormNames, formFields } from "../../../utils";
import { SearchView } from "../SearchView";
import { CardsLayout } from "../CardsLayout";
import ExcelImage from "../../../styles/exportimg.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { isEmpty } from "lodash";
const columns = [
  {
    id: "clearingPartnerId",
    label: "Clearing Partner ID",
    style: { fontSize: "14px", width: "17%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-17",
  },
  {
    id: "cusip",
    label: "CUSIP",
    style: { paddingLeft: "0.5rem", fontSize: "14px", width: "16.6%" },
    className: "grey-text font-weight-700",
    styleName: "investment-cusip-col w-166",
  },
  {
    id: "unitsOnCore",
    label: "Units on CORE",
    style: { fontSize: "14px", width: "16.6%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-166",
  },
  {
    id: "unitsOnClearingPartner",
    label: "Units on Clearing Partner",
    style: { fontSize: "14px", width: "16.6%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-166",
  },
  {
    id: "unitDifference",
    label: "Unit Difference",
    style: { fontSize: "14px", width: "16.6%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-166",
  },
  {
    id: "date",
    label: "Date",
    style: {
      fontSize: "14px",
      width: "16.6%",
    },
    className: "grey-text font-weight-700",
    styleName: "trade-flex-column w-166 justify-content-center",
  },
];

const TradeReconcilationContainer = (props) => {
  const TableContent = {
    cusip: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    clearingPartnerId: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    unitsOnCore: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    unitsOnClearingPartner: (a, e) => (
      <div className={a.styleName}>XXXX2345</div>
    ),
    unitDifference: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    date: (a, e) => {
      return (
        <div className={a.styleName}>
          <div className="transaction-card-top-row">{"6/6/2023 5:40"}</div>
        </div>
      );
    },
  };
  const onSubmit = () => {};
  return (
    <CardsLayout>
      <div className="column-filters">
        {columns.map((_) => (
          <div className={_.className} style={{ ..._.style }}>
            {" "}
            {_.label}
          </div>
        ))}
      </div>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((e, i) => {
        return (
          <div className="generic-table-component investment-trade-component">
            {columns.map((a, b) => {
              console.log(a, "regs");
              // const args = {...a,...e}
              return TableContent[a.id](a, e);
            })}
          </div>
        );
      })}
    </CardsLayout>
  );
};

export default TradeReconcilationContainer;
